import { transformOptionField, MAX_OPTION_DISPLAY_LENGTH } from '../../../utils';
export default {
    name: 'OptionRender',
    props: {
        field: {
            type: Object,
            required: true,
        },
        value: {
            type: Array,
            default: null,
        },
    },
    computed: {
        formattedValue() {
            const items = transformOptionField(this.value, this.field.field_option_value);
            if (items.length > MAX_OPTION_DISPLAY_LENGTH) {
                return {
                    items: items.slice(0, MAX_OPTION_DISPLAY_LENGTH),
                    more: items.length - MAX_OPTION_DISPLAY_LENGTH,
                };
            }
            return {
                items,
                more: 0,
            };
        },
    },
};
